import { IbanFieldComponent } from './../../../../shared/components/iban-field/iban-field.component';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { IBreadcrumbConfig } from '../../../../core/interfaces/breadcrumb-config';
import { ModalConfirmEditComponent } from '../../components/modal-confirm-edit/modal-confirm-edit.component';
import { InsuranceService } from 'src/app/core/services/insurance.service';
import { IPolicyRequest } from '@interfaces/policy-request.interface';
import { Router } from '@angular/router';
import { IPolicyResponse } from '@interfaces/policy-response.interface';
import { ModalEditIbanComponent } from '../../components/modal-edit-iban/modal-edit-iban.component';
import { DataService } from 'src/app/core/services/data.service';

@Component({
  standalone: true,
  selector: 'aig-modify-data',
  imports: [
    BreadcrumbComponent,
    ReactiveFormsModule,
    IbanFieldComponent,
    ModalConfirmEditComponent,
    ModalEditIbanComponent,
  ],
  templateUrl: './modify-data.component.html',
  styleUrl: './modify-data.component.scss',
})
export class ModifyDataComponent implements OnInit {
  public modifiedDataForm: FormGroup = new FormGroup({});
  public ibanMandatory: boolean = false;
  public initialValues: any;
  public IdPoliza!: number;
  public policyResponse: IPolicyResponse | undefined;
  public IbanModificado: boolean = false;
  public IbanLastDigits: string | null = null;


  public visibleConfirmEditModal: boolean = false;
  public visibleEditIbanModal: boolean = false;

  formData: any;

  constructor(
    private fb: FormBuilder,
    private insuranceService: InsuranceService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.buildForm();
    this.cargarFormulario();

    // Espera a que el formulario se cargue antes de establecer los valores iniciales
    this.modifiedDataForm.valueChanges.subscribe(() => {
      this.cdr.detectChanges(); // Forzar detección de cambios en la vista
    });
  }
  private buildForm(): void {
    this.modifiedDataForm = this.fb.group({
      tomador: [{ value: '', disabled: true }, [Validators.required]],
      nacionalidad: [{ value: '', disabled: true }, [Validators.required]],
      dni: [{ value: '', disabled: true }, [Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      telefono: ['+34', [Validators.required, Validators.pattern('[0-9]*')]],
      iban1: ['', [Validators.required]],
      iban2: ['', [Validators.required]],
      iban3: ['', [Validators.required]],
      iban4: ['', [Validators.required]],
      iban5: ['', [Validators.required]],
      iban: new FormControl('', Validators.required),
      direccion: ['', [Validators.required]],
      bloque: [''],
      piso: [''],
      puerta: [''],
      provincia: ['', Validators.required],
      cp: ['', Validators.required],
      poblacion: ['', Validators.required],
      pais: ['', Validators.required],
    });

    //this.initialValues = this.modifiedDataForm.value;
  }

  public formHasChanged(): boolean {
    if (!this.initialValues) {
      return false;
    }

    return Object.entries(this.initialValues).some(
      ([field, value]) =>
        JSON.stringify(value) !==
        JSON.stringify(this.modifiedDataForm.value[field])
    );
  }

  public cargarFormulario() {
    const navigation = history.state;
    this.policyResponse = navigation.policy;
    this.IdPoliza =  this.dataService.getPoliza();;

    // Si alguno de los valores es undefined, redirigir a ClientAreaComponent
    
    // Está comentado para poder navegar desde la poliza inexistente de prueba
    // Lo malo que no se vé ningún dato con la póliza inexistente
    
    // if (!this.policyResponse || !this.IdPoliza) {
    //   this.router.navigate(['/client-area']); // Ajusta la ruta según tu configuración de rutas
    //   return;
    // }


    //const numDocumento = localStorage.getItem('num_documento');

    // Concatenar nombre y apellidos para el campo 'holder'
    const tomador =
      `${this.policyResponse?.nombre} ${this.policyResponse?.apellidos}`.trim();

    const iban = this.policyResponse?.iban || '';
    const iban1 = iban.substring(2, 4);
    const iban2 = iban.substring(4, 8);
    const iban3 = iban.substring(8, 12);
    const iban4 = iban.substring(12, 14);
    const iban5 = iban.substring(14); // El resto de caracteres

    this.IbanLastDigits = iban.slice(-4);

    // Habilitar los campos temporalmente
    this.modifiedDataForm.get('tomador')?.enable({ emitEvent: false });
    this.modifiedDataForm.get('dni')?.enable({ emitEvent: false });

    this.modifiedDataForm.patchValue({
      tomador: tomador,
      dni: this.policyResponse?.num_Documento,
      email: this.policyResponse?.email,
      nacionalidad: this.policyResponse?.nacionalidad,
      telefono: `${this.policyResponse?.telefono}`,
      iban1,
      iban2,
      iban3,
      iban4,
      iban5,
      direccion: this.policyResponse?.direccion,
      bloque: this.policyResponse?.bloque,
      piso: this.policyResponse?.piso ?? '', // Si 'piso' no viene, asignamos una cadena vacía
      puerta: this.policyResponse?.puerta ?? '', // Si 'puerta' no viene, asignamos una cadena vacía
      provincia: this.policyResponse?.provincia,
      cp: this.policyResponse?.codigo_postal,
      poblacion: this.policyResponse?.poblacion,
      pais: this.policyResponse?.pais,
    });

    // Volver a deshabilitar los campos después de asignar los valores
    this.modifiedDataForm.get('tomador')?.disable({ emitEvent: false });
    this.modifiedDataForm.get('dni')?.disable({ emitEvent: false });

    // Guarda los valores iniciales después de que se complete la carga de datos
    this.initialValues = structuredClone(this.modifiedDataForm.value);

    // Deshabilita el formulario si idEstado no es 1
    if (this.policyResponse?.idEstado !== 1) {
      this.modifiedDataForm.disable();
    }
  }

  public saveChanges() {
    const formValues = this.modifiedDataForm.getRawValue();
    const formData: IPolicyRequest = {
      nombre: this.policyResponse?.nombre ?? '',
      apellidos: this.policyResponse?.apellidos ?? '',
      fecha_Nacimiento: this.policyResponse?.fecha_Nacimiento ?? '',
      nacionalidad: formValues.nacionalidad,
      num_Documento: formValues.dni,
      email: formValues.email,
      prefijo: this.policyResponse?.prefijo,
      telefono: formValues.telefono,
      direccion: formValues.direccion,
      bloque: formValues.bloque,
      piso: formValues.piso,
      puerta: formValues.puerta,
      poblacion: formValues.poblacion,
      provincia: formValues.provincia,
      codigo_postal: formValues.cp.toString(),
      pais: formValues.pais,
      iban: formValues.iban, // Incluye el país
      ibanModificado: this.IbanModificado,
    };


    this.insuranceService
      .modificarDatosPoliza(this.IdPoliza, formData)
      .subscribe({
        next: (response) => {
          this.visibleConfirmEditModal = true;
        },
        error: (error) => {
          console.error('Error al modificar los datos:', error);
        },
      });
  }

  public CloseModal() {
    this.visibleConfirmEditModal = false;
    this.router.navigate(['area-cliente']);
  }

  public updateIban(iban: string): void {
    this.modifiedDataForm.patchValue({ iban });
  }

  public editIBAN(): void {
    if ([false, null, undefined].includes(this.IbanModificado)) {
      this.visibleEditIbanModal = true;
    }
  }

  onValidationResult(isValid: boolean): void {
    if (isValid) {
      // Aquí puedes hacer lo que necesites, como actualizar un formulario
      this.IbanModificado = true;
      // Vaciar los valores de los campos IBAN en el formulario
      this.modifiedDataForm.patchValue({
        iban1: '',
        iban2: '',
        iban3: '',
        iban4: '',
        iban5: '',
      });
    } else {
    }
  }
}
